<template>
    <v-tabs centered color="white">
        <v-icon v-if="isPro" class="custom_return_icon" @click="experiencesRedirection">
            fas fa-angle-left
        </v-icon>
        <v-tabs-slider class="custom_tabs_slider" />
        <v-tab v-for="(tab, index) in tabsFilter" :key="index" :href="'#tab-' + (index + 1)"
               :class="!isPro && index === 0 ? 'fix_margin_tab' : ''">
            <v-icon :class="[isMobile ? 'active' : '']" class="custom_tab_icon">
                fas fa-{{ tab.icon }}
            </v-icon>
            <div v-if="!isMobile" class="custom_tab_text">
                {{ tab.title }}
            </div>
        </v-tab>
        <v-tab-item v-for="(tab, index) in tabs" :key="index" :value="'tab-' + (index + 1)" class="custom_tab_item">
            <augmentations-tab-list v-if="tab.component === 'augmentationsCards'" />
            <augmentations-tab-parameters v-if="tab.component === 'augmentationsParameters' && isPro" />
            <augmentations-tab-publish v-if="tab.component === 'augmentationsPublish' && isPro" />
        </v-tab-item>
    </v-tabs>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'AugmentationsContent',
        components: {
            AugmentationsTabList: () => import('./AugmentationsTabList'),
            AugmentationsTabParameters: () => import('./AugmentationsTabParameters'),
            AugmentationsTabPublish: () => import('./AugmentationsTabPublish')
        },
        data: () => ({
            tabs: [
                { icon: 'eye', title: 'Mes augmentations', component: 'augmentationsCards' },
                { icon: 'cog', title: 'Paramètres', component: 'augmentationsParameters' },
                { icon: 'briefcase', title: 'Publier', component: 'augmentationsPublish' }
            ]
        }),
        computed: {
            ...mapGetters('app', ['isPro', 'isMobile']),
            ...mapGetters('augmentations', ['mode', 'experience']),
            tabsFilter: function () {
                return this.isPro ? this.tabs : [this.tabs[0]];
            }
        },
        methods: {
            experiencesRedirection: function () {
                this.$router.push({ name: 'experiences' });
            }
        }
    };
</script>

<style lang="scss" scoped>

    .custom_tabs_slider {
        background-color: #169CEB;
    }

    .custom_tab_icon {
        margin-right: 10px;
        font-size: 20px;
    }

    .custom_tab_icon.active {
        margin-left: 10px;
    }

    .custom_tab_text {
        text-transform: capitalize;
    }

    .custom_return_icon {
        margin-left: 0 !important;
        width: 70px;
    }

    .custom_tab_item {
        background-color: #F1F1F1;
        min-height: calc(100vh - 223px) !important;
    }

    .container.grid-list-md {
        min-width: 100% !important;
    }

    .fix_margin_tab {
        margin-left: 70px !important;
    }

    .v-tab.v-tab {
        color: rgba(0, 0, 0, 0.54);
    }
</style>
